import { render, staticRenderFns } from "./ProcessedData.vue?vue&type=template&id=6d81739e&scoped=true"
import script from "./ProcessedData.vue?vue&type=script&lang=js"
export * from "./ProcessedData.vue?vue&type=script&lang=js"
import style0 from "./ProcessedData.vue?vue&type=style&index=0&id=6d81739e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d81739e",
  null
  
)

export default component.exports